"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _propTypes = require("prop-types");

var _TruncatedTextComponent = _interopRequireDefault(require("./TruncatedTextComponent"));

var _utils = require("../../utils");

var _excluded = ["content", "charCount", "maxLines"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var createShowMapping = function createShowMapping(index, baseMap) {
  return (0, _ramda.insert)(index, "inherit", baseMap);
};

var TruncatedTextContainer = function TruncatedTextContainer(_ref) {
  var content = _ref.content,
      charCount = _ref.charCount,
      maxLines = _ref.maxLines,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var truncatedContent = (0, _react.useMemo)(function () {
    if ((0, _ramda.isNil)(charCount)) {
      return [];
    }

    var counts = (0, _ramda.flatten)([charCount]);
    var baseMap = (0, _ramda.repeat)("none", (0, _ramda.length)(counts) - 1);
    return (0, _utils.mapIndexed)(function (count, index) {
      return {
        display: baseMap ? createShowMapping(index, baseMap) : "inherit",
        html: content.length > count ? (0, _utils.truncateHtml)(content, count) : content
      };
    }, counts);
  }, [charCount, content]);
  var max = (0, _react.useMemo)(function () {
    return !(0, _ramda.isNil)(maxLines) ? (0, _ramda.map)(_ramda.toString, (0, _ramda.flatten)([maxLines])) : null;
  }, [maxLines]);
  return /*#__PURE__*/_react["default"].createElement(_TruncatedTextComponent["default"], _extends({
    content: content,
    maxLines: max,
    truncatedContent: truncatedContent
  }, props));
};

TruncatedTextContainer.propTypes = {
  charCount: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.number), _propTypes.number]),
  content: _propTypes.string,
  maxLines: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.number), _propTypes.number])
};
TruncatedTextContainer.defaultProps = {
  charCount: [Infinity],
  content: ""
};
var _default = TruncatedTextContainer;
exports["default"] = _default;